import { Injectable, NgModule } from '@angular/core';
import { CanDeactivate, RouterModule, Routes } from '@angular/router';

import { VendorDetailsPage } from './vendor-details.page';

import { getVendorIdResolver } from '../../core/resolvers/get-vendor-id.resolver';

@Injectable({ providedIn: 'root' })
class VendorDetailsPageCanDeactivateGuard implements CanDeactivate<VendorDetailsPage> {
  canDeactivate(view: VendorDetailsPage): boolean {
    return view.finishedLoadingPage;
  }
}

const routes: Routes = [
  {
    path: '',
    component: VendorDetailsPage,
    canDeactivate: [VendorDetailsPageCanDeactivateGuard],
    resolve: { vendorId: getVendorIdResolver },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VendorDetailsPageRoutingModule {}
